import { selectors, useDispatch, useSelector } from '@sloyd/store-base';
import { useMemo } from 'react';
import { ContentGenerators } from './ContentGenerators';

export type ContentGeneratorsContainerProps = {};

export function ContentGeneratorsContainer(_props: ContentGeneratorsContainerProps) {
  const dispatch = useDispatch();
  const allGenerators = useSelector(selectors.gallery.$generators);
  const appState = useSelector(selectors.raw.$rawAppState);
  const palettes = useSelector(selectors.base.$palettes);
  const settings = useSelector(selectors.raw.$rawSettings);
  const { isLoading } = appState;
  const { whiteThumbnails } = settings;

  const callbacks = useMemo(
    () => ({
      onAction: (action: Action) => {
        dispatch(action);
      },
    }),
    []
  );

  return (
    <ContentGenerators
      whiteThumbnails={whiteThumbnails}
      generators={allGenerators}
      palettes={palettes}
      isLoading={isLoading}
      callbacks={callbacks}
    />
  );
}

export default ContentGeneratorsContainer;
